// extracted by mini-css-extract-plugin
export default {"FormButton":"button_FormButton__73YSF"};